import { InjectionToken } from '@angular/core';
import { NoticeOfPrivacyPracticesService } from '../services/compliance/notice-of-privacy-practices.interface';

export const NOTICE_OF_PRIVACY_PRACTICES_SERVICE =
  new InjectionToken<NoticeOfPrivacyPracticesService>(
    'NOTICE_OF_PRIVACY_PRACTICES_SERVICE'
  );
